<!-- eslint-disable vue/no-unused-vars -->

<template>
  <v-expansion-panels flat class="flat-expanssion-panel">
    <v-expansion-panel>
      <v-expansion-panel-header ripple color="grey lighten-4" class="accent--text d-flex align-center justify-content-between">
        <v-tooltip color="white" v-if="contentJson?.lang?.[language]?.text || contentJson?.text" right content-class="tooltip-box-content" max-width="360" :open-delay="300" :close-delay="200" transition="slide-x-transition">
          <template v-slot:activator="{on, attrs}">
            <div v-bind="attrs" v-on="on" style="margin-right: -40px">
              {{ $t("soil-use-and-risks") }}
              <span v-if="hasAtLeastOneWarning" style="color: red; font-size: 15px">&#9888;</span>
            </div>
          </template>
          <div v-html="contentJson?.lang?.[language]?.text || contentJson?.text"></div>
        </v-tooltip>
        <div v-else>
          {{ $t("soil-use-and-risks") }}
          <span v-if="hasAtLeastOneWarning" style="color: red; font-size: 15px">&#9888;</span>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <TooltipTR section="section600" field="GRN_SOI" :label="$t('building-ground-assumption')">
                <div>{{ $t("building-ground-assumption") }}</div>
                <div>{{ plotItem.GRN_SOI }}</div>
              </TooltipTR>
              <TooltipTR section="section600" field="GRN_TRM" :label="$t('use-of-geothermal-probes')">
                <div><b>{{ $t("use-of-geothermal-probes") }}</b></div>
                <div><b>{{ plotItem.GRN_TRM }}</b></div>
              </TooltipTR>
              <TooltipTR section="section600" field="GRN_GWU" :label="$t('use-of-groundwater')">
                <div><b>{{ $t("use-of-groundwater") }}</b></div>
                <div><b>{{ plotItem.GRN_GWU }}</b></div>
              </TooltipTR>
              <TooltipTR section="section600" field="GRN_RAD" :label="$t('radon-content')">
                <div>
                  <b>{{ $t("radon-content") }} ({{ plotItem.GRN_RAD_UNIT }}) <span v-if="plotItem.GRN_RAD_LABEL == 'Y'" style="color: red; font-size: 20px;line-height: 1;">&#9888;</span></b>
                </div>
                <div>
                  <b>{{ plotItem.GRN_RAD }}</b>
                  <span>{{ plotItem.GRN_RAD_UNIT }} </span>
                </div>
              </TooltipTR>
              <TooltipTR section="section600" field="GRN_CON" :label="$t('site-contamination-kbs')">
                <div>{{ $t("site-contamination-kbs") }} <span v-if="plotItem.GRN_CON_LABEL == 'Y'" style="color: red; font-size: 20px;line-height: 1;">&#9888;</span></div>
                <div>
                  {{ plotItem.GRN_CON_TY }} 
                  <div>{{ plotItem.GRN_CON_ST }}</div>
                </div>
              </TooltipTR>
            </tbody>
          </template>
        </v-simple-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator"
import TooltipTR from "./TooltipText.vue"

@Component({
  components: {TooltipTR},
})
export default class ViewPlotDetails300 extends Vue {
  @Prop()
  plotItem

  contentJson: any = {}
  language

  created() {
    this.language = localStorage.getItem("user-language") || "en"
    this.loadTooltip()
  }

  async loadTooltip() {
    // ask tooltip module to load the JSON for the prefix (it caches by prefix)
    // and get the specific content entry in one awaited call
    this.contentJson = (await this.$store.dispatch("tooltip/getTooltipContent", "section600")) || {}
  }

  get hasAtLeastOneWarning() {
    if (this.plotItem.GRN_RAD_LABEL == "Y" || this.plotItem.GRN_CON_LABEL == "Y") {
      return true
    }
    return false
  }

}
</script>
